/* eslint-disable valid-typeof */
import { ChatApi } from "generated/apiChats";
import { Configuration } from "generated/configuration";
import { getLoggedinUser } from "helpers/api_helper";

const { REACT_APP_API_URL } = process.env;

export const createChat = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new ChatApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.chatControllerCreate(data);
};

export const createMessageByChatId = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new ChatApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.chatControllerCreateMessage({...data, userId: authUser.uid});
};



export const deleteBulkChat = async (data: any) => {
  const authUser: any = getLoggedinUser();
  const api = new ChatApi(
    new Configuration({
      accessToken: authUser.accessToken || "",
      basePath: `${REACT_APP_API_URL}`,
    })
  );
  return api.chatControllerDelete(data);
};



 